// extracted by mini-css-extract-plugin
module.exports = {"container":"NodePalette__container___v8bmd","search":"NodePalette__search___zXxU6","title":"NodePalette__title___4xLhD"};